export class EguardNavigation {
  public verticalNavItems: any[];
  public horizontalNavItems: any[];

  constructor() {
    this.verticalNavItems = [
      {
        'role': 'CLERK',
        'id': 'applications',
        'title': 'Applications',
        'type': 'group',
        'icon': 'apps',
        'children': [

          {
            'title': 'Dashboard',
            'type': 'nav-item',
            'icon': 'dashboard',
            'url': 'dashboard'
          },
          {
            'title': 'Cases',
            'type': 'nav-item',
            'icon': 'assignment',
            'url': 'cases'
          },
          {
            'title': 'Users',
            'type': 'nav-item',
            'icon': 'person',
            'url': 'users'
          },

          {
            'title': 'Reports',
            'type': 'nav-item',
            'icon': 'bar_chart',
            'url': 'reports'
          },
          {
            'title': 'Calendar',
            'type': 'nav-item',
            'icon': 'event',
            'url': 'calendar'
          },
          {
            'title': 'ToDo',
            'type': 'nav-item',
            'icon': 'check_circle',
            'url': 'todo'
          },
          {
            'title': 'Payments',
            'type': 'nav-item',
            'icon': 'payment',
            'url': 'payments'
          },
          {
            'title': 'Settings',
            'type': 'nav-item',
            'icon': 'settings',
            'url': 'settings'
          }, {
            'title': 'Logout',
            'type': 'nav-item',
            'icon': 'exit_to_app',
            'url': 'logout'
          }]
      },
      {
        'role': 'PETITIONER',
        'id': 'applications',
        'title': 'Applications',
        'type': 'group',
        'icon': 'apps',
        'children': [
          {
            'title': 'Dashboard',
            'type': 'nav-item',
            'icon': 'dashboard',
            'url': 'dashboard'
          },
          {
            'title': 'Calendar',
            'type': 'nav-item',
            'icon': 'event',
            'url': 'calendar'
          },
          {
            'title': 'ToDo',
            'type': 'nav-item',
            'icon': 'check_circle',
            'url': 'todo'
          },
          {
            'title': 'Payments',
            'type': 'nav-item',
            'icon': 'payment',
            'url': 'payments'
          },

          {
            'title': 'Settings',
            'type': 'nav-item',
            'icon': 'settings',
            'url': 'settings'
          }, {
            'title': 'Logout',
            'type': 'nav-item',
            'icon': 'exit_to_app',
            'url': 'logout'
          }]
      },

      {
        'role': 'GUARDIANADLITEM',
        'id': 'applications',
        'title': 'Applications',
        'type': 'group',
        'icon': 'apps',
        'children': [
          {
            'title': 'Dashboard',
            'type': 'nav-item',
            'icon': 'dashboard',
            'url': 'dashboard'
          },
          {
            'title': 'Calendar',
            'type': 'nav-item',
            'icon': 'event',
            'url': 'calendar'
          },
          {
            'title': 'ToDo',
            'type': 'nav-item',
            'icon': 'check_circle',
            'url': 'todo'
          },
          {
            'title': 'Settings',
            'type': 'nav-item',
            'icon': 'settings',
            'url': 'settings'
          }, {
            'title': 'Logout',
            'type': 'nav-item',
            'icon': 'exit_to_app',
            'url': 'logout'
          }]
      },


      {
        'role': 'ATTORNEY',
        'id': 'applications',
        'title': 'Applications',
        'type': 'group',
        'icon': 'apps',
        'children': [
          {
            'title': 'Dashboard',
            'type': 'nav-item',
            'icon': 'dashboard',
            'url': 'dashboard'
          },
          {
            'title': 'Calendar',
            'type': 'nav-item',
            'icon': 'event',
            'url': 'calendar'
          },
          {
            'title': 'ToDo',
            'type': 'nav-item',
            'icon': 'check_circle',
            'url': 'todo'
          },
          {
            'title': 'Payments',
            'type': 'nav-item',
            'icon': 'payment',
            'url': 'payments'
          },

          {
            'title': 'Settings',
            'type': 'nav-item',
            'icon': 'settings',
            'url': 'settings'
          }, {
            'title': 'Logout',
            'type': 'nav-item',
            'icon': 'exit_to_app',
            'url': 'logout'
          }]
      },


      {
        'role': 'JUDGE',
        'id': 'applications',
        'title': 'Applications',
        'type': 'group',
        'icon': 'apps',
        'children': [
          {
            'title': 'Dashboard',
            'type': 'nav-item',
            'icon': 'dashboard',
            'url': 'dashboard'

          },
          {
            'title': 'Reports',
            'type': 'nav-item',
            'icon': 'bar_chart',
            'url': 'reports'
          },
          {
            'title': 'Calendar',
            'type': 'nav-item',
            'icon': 'event',
            'url': 'calendar'
          },
          {
            'title': 'ToDo',
            'type': 'nav-item',
            'icon': 'check_circle',
            'url': 'todo'
          },
          {
            'title': 'Settings',
            'type': 'nav-item',
            'icon': 'settings',
            'url': 'settings'
          }, {
            'title': 'Logout',
            'type': 'nav-item',
            'icon': 'exit_to_app',
            'url': 'logout'
          }]
      },
      {
        'role': 'GUARDIAN',
        'id': 'applications',
        'title': 'Applications',
        'type': 'group',
        'icon': 'apps',
        'children': [
          {
            'title': 'Dashboard',
            'type': 'nav-item',
            'icon': 'dashboard',
            'url': 'dashboard'
          },
          {
            'title': 'Calendar',
            'type': 'nav-item',
            'icon': 'event',
            'url': 'calendar'
          },
          {
            'title': 'ToDo',
            'type': 'nav-item',
            'icon': 'check_circle',
            'url': 'todo'
          },
          {
            'title': 'Payments',
            'type': 'nav-item',
            'icon': 'payment',
            'url': 'payments'
          },
          {
            'title': 'Settings',
            'type': 'nav-item',
            'icon': 'settings',
            'url': 'settings'
          }, {
            'title': 'Logout',
            'type': 'nav-item',
            'icon': 'exit_to_app',
            'url': 'logout'
          }]
      }, {
        'role': 'HEIR',
        'id': 'applications',
        'title': 'Applications',
        'type': 'group',
        'icon': 'apps',
        'children': [
          {
            'title': 'Dashboard',
            'type': 'nav-item',
            'icon': 'dashboard',
            'url': 'dashboard'
          },
          {
            'title': 'Calendar',
            'type': 'nav-item',
            'icon': 'event',
            'url': 'calendar'
          },
          {
            'title': 'ToDo',
            'type': 'nav-item',
            'icon': 'check_circle',
            'url': 'todo'
          },
          {
            'title': 'Payments',
            'type': 'nav-item',
            'icon': 'payment',
            'url': 'payments'
          },
          {
            'title': 'Settings',
            'type': 'nav-item',
            'icon': 'settings',
            'url': 'settings'
          }, {
            'title': 'Logout',
            'type': 'nav-item',
            'icon': 'exit_to_app',
            'url': 'logout'
          }]
      },
    ];

    this.horizontalNavItems = [
      {
        'title': 'Apps',
        'icon': 'apps',
        'type': 'nav-collapse',
        'children': [
          {
            'title': 'Dashboard',
            'type': 'nav-item',
            'icon': 'dashboard',
            'url': 'dashboard'
          },
          {
            'title': 'Cases',
            'type': 'nav-item',
            'icon': 'search',
            'url': 'cases'
          },
          {
            'title': 'Organizations',
            'type': 'nav-item',
            'icon': 'location_city',
            'url': 'organizations'
          },
          {
            'title': 'Calendar',
            'type': 'nav-item',
            'icon': 'event',
            'url': 'calendar'
          },
          {
            'title': 'ToDo',
            'type': 'nav-item',
            'icon': 'check_circle',
            'url': 'todo'
          },
          {
            'title': 'Payments',
            'type': 'nav-item',
            'icon': 'payment',
            'url': 'payments'
          },
          {
            'title': 'Settings',
            'type': 'nav-item',
            'icon': 'settings',
            'url': 'settings'
          }, {
            'title': 'Logout',
            'type': 'nav-item',
            'icon': 'exit_to_app',
            'url': 'logout'
          }
        ]
      }
    ];
  }
}



// WEBPACK FOOTER //
// ./src/app/navigation.model.ts